const blockHubspotForms = document.querySelectorAll<HTMLElement>('[data-hubspot-form]');

function createHubspotForms() {
	blockHubspotForms.forEach((el) => {
		window.hbspt.forms.create({
			portalId: el.getAttribute('data-hubspot-portal-id'),
			formId: el.getAttribute('data-hubspot-form'),
			target: '#' + el.id,
			cssRequired: '',
			css: '',
			locale: document.documentElement.getAttribute('lang'),
		});
	});
}

if (blockHubspotForms.length > 0) {
	if (window.hbspt?.forms) {
		createHubspotForms();
	} else {
		window.addEventListener('impulse:delayed-scripts-loaded', createHubspotForms, {
			once: true,
		});
	}
}
